import React from 'react';
import { Stack, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const WelcomeSectionContainer = styled(Box)(({ theme }) => ({
  background: '#ffffff',
  borderRadius: '12px',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
  border: '1px solid rgba(0, 0, 0, 0.04)',
  padding: '24px 16px',
  marginBottom: '16px',
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    borderRadius: '14px',
    padding: '32px 24px',
    marginBottom: '24px',
    boxShadow: '0 3px 18px rgba(0, 0, 0, 0.06)'
  },
  [theme.breakpoints.up('md')]: {
    borderRadius: '16px',
    padding: '40px 32px',
    marginBottom: '32px',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.06)'
  }
}));

const LogoContainer = styled(Stack)(({ theme }) => ({
  gap: '10px',
  alignItems: 'center',
  marginBottom: '4px',
  [theme.breakpoints.up('sm')]: {
    gap: '12px',
    marginBottom: '6px'
  },
  [theme.breakpoints.up('md')]: {
    gap: '16px',
    marginBottom: '8px'
  }
}));

const VisibeenLogo = styled('img')(({ theme }) => ({
  width: '100px',
  height: '36px',
  objectFit: 'contain',
  [theme.breakpoints.up('sm')]: {
    width: '120px',
    height: '42px'
  },
  [theme.breakpoints.up('md')]: {
    width: '140px',
    height: '48px'
  }
}));

const WelcomeText = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  fontSize: '13px',
  fontWeight: 500,
  color: '#64748b',
  letterSpacing: '0.02em',
  [theme.breakpoints.up('sm')]: {
    fontSize: '14px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '15px'
  }
}));

const CompanyName = styled(Typography)(({ theme }) => ({
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',
  fontSize: '22px',
  fontWeight: 700,
  color: '#0B91D6',
  letterSpacing: '-0.3px',
  marginTop: '4px',
  [theme.breakpoints.up('sm')]: {
    fontSize: '26px',
    letterSpacing: '-0.4px',
    marginTop: '6px'
  },
  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
    letterSpacing: '-0.5px',
    marginTop: '8px'
  }
}));

const WelcomeSection = () => {
  return (
    <WelcomeSectionContainer>
      <LogoContainer>
        <VisibeenLogo 
          src="/images/visibeen-logo.png" 
          alt="Visibeen Logo" 
        />
        <WelcomeText>Welcome</WelcomeText>
      </LogoContainer>
      <CompanyName>E2E Digitech Pvt Ltd</CompanyName>
    </WelcomeSectionContainer>
  );
};

export default WelcomeSection;